import React, { useEffect, useState } from "react";

const OfferPopup = ({
  id = "home-offer-2026",
  title = "Welcome to Shoplintic 🎉",
  description = "Get flat 50% OFF on your first order. Limited time offer!",
  coupon = "OFF50",
  buttonText = "Shop Now",
  buttonLink = "/product",
}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem(id);
    if (!seen) {
      setTimeout(() => setShow(true), 500);
    }
  }, [id]);

  const closePopup = () => {
    localStorage.setItem(id, "seen");
    setShow(false);
  };

  if (!show) return null;

  return (
    <>
      {/* INLINE CSS */}
      <style>{`
        .offer-popup-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 99999;
        }

        .offer-popup {
          background: #fff;
          width: 90%;
          max-width: 360px;
          border-radius: 16px;
          padding: 24px 20px;
          text-align: center;
          box-shadow: 0 20px 50px rgba(0,0,0,0.25);
          position: relative;
          animation: scaleIn 0.3s ease;
        }

        .offer-close {
          position: absolute;
          top: 10px;
          right: 12px;
          background: none;
          border: none;
          font-size: 22px;
          cursor: pointer;
          color: #666;
        }

        .offer-emoji {
          font-size: 48px;
          margin-bottom: 10px;
        }

        .offer-title {
          font-size: 22px;
          font-weight: 700;
          margin-bottom: 8px;
        }

        .offer-desc {
          font-size: 14px;
          color: #666;
          margin-bottom: 14px;
          line-height: 1.6;
        }

        .offer-coupon {
          background: #f3f6ff;
          border: 1px dashed #0d6efd;
          border-radius: 10px;
          padding: 8px 12px;
          font-size: 16px;
          font-weight: 700;
          color: #0d6efd;
          margin-bottom: 16px;
          display: inline-block;
        }

        .offer-btn {
          background: linear-gradient(135deg,#ff4d79,#ff8c3a);
          color: #fff;
          border: none;
          border-radius: 10px;
          padding: 10px 18px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          text-decoration: none;
          display: inline-block;
          width: 100%;
        }

        @keyframes scaleIn {
          from { transform: scale(0.9); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
      `}</style>

      {/* OVERLAY (click outside closes) */}
      <div
        className="offer-popup-overlay"
        onClick={closePopup}
      >
        {/* POPUP (stop click bubbling) */}
        <div
          className="offer-popup"
          onClick={(e) => e.stopPropagation()}
        >
          <button className="offer-close" onClick={closePopup}>
            ✕
          </button>

          <div className="offer-emoji">🎁</div>

          <h3 className="offer-title">{title}</h3>

          <p className="offer-desc">{description}</p>

          {coupon && (
            <div className="offer-coupon">
              Use Code: {coupon}
            </div>
          )}

          <a
            href={buttonLink}
            className="offer-btn"
            onClick={closePopup}
          >
            {buttonText}
          </a>
        </div>
      </div>
    </>
  );
};

export default OfferPopup;
